import './styles/DateBox.scss';

import { Icon } from '@mui/material';

import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface Props {
  startDate?: Date;
  endDate?: Date;
  startText?: string;
  endText?: string;
  icon?: ReactElement;
}

export const DateBox = ({ startDate, endDate, startText, endText, icon }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="date-box">
      {!!icon ? icon : <Icon className="fas fa-calendar-alt" />}
      {!!startText
        ? startText
        : t(translations.pages.moduleSelections.create.periodsAndExtraInfo.startDate())}{' '}
      {startDate
        ? new Date(startDate).toLocaleString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          })
        : '-/-'}
      <br />
      {!!endText
        ? endText
        : t(translations.pages.moduleSelections.create.periodsAndExtraInfo.endDate())}{' '}
      {endDate
        ? new Date(endDate).toLocaleString('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          })
        : '-/-'}
    </div>
  );
};
